// How the health score is calculated, in words: one name and one rule per
// part of the score (packages/core/repo/home_health.go). Read by the
// programme report's appendix and by Home's "Why?" drawer, so the two can
// never explain the same score two ways.

export const HEALTH_PART: Record<string, string> = {
  coverage: 'Coverage',
  overdue: 'Overdue work',
  findings: 'Critical and high findings',
  exits: 'Offboarding',
  statutory: 'Statutory gaps',
  acceptances: 'Expired acceptances',
}

export const HEALTH_RULE: Record<string, string> = {
  coverage: 'Up to 25: the share of live vendors without a current score.',
  overdue: 'Up to 20: overdue questionnaires, findings and reassessments, as a share of live vendors.',
  findings: 'Up to 25: 5 for each critical and 2 for each high finding open.',
  exits: 'Up to 10: 5 for each offboarding late or blocked, 2 for each proposal waiting a week.',
  statutory: 'Up to 10: the share of live vendors with an identifier missing.',
  acceptances: 'Up to 10: 5 for each risk acceptance past its expiry and still approved.',
}

// Points as the report writes them: whole where whole, else one decimal.
export function healthPoints(n: number): string {
  return n.toFixed(n % 1 === 0 ? 0 : 1)
}
